import { render, staticRenderFns } from "./PeriodeForm.vue?vue&type=template&id=1370fd1f&scoped=true&"
import script from "./PeriodeForm.vue?vue&type=script&lang=js&"
export * from "./PeriodeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1370fd1f",
  null
  
)

export default component.exports